import { workflowTheme } from "../../utils/workflowBuilderTheme";

export const inspectorInputClass = `text-sm h-9 shadow-sm ${workflowTheme.input}`;
export const errorInputStyle = { borderColor: '#ef4444', boxShadow: '0 0 0 1px #ef4444' };
export const inspectorTextareaClass = `text-sm min-h-[96px] shadow-sm ${workflowTheme.input}`;
export const inspectorTextareaMonoClass = `text-sm min-h-[96px] font-mono text-xs shadow-sm ${workflowTheme.input}`;
export const inspectorSelectClass = `w-full h-9 rounded-md px-3 py-1 text-sm shadow-sm dark:scheme-dark ${workflowTheme.input}`;
